import {
  Component,
  OnInit,
  NgZone,
  Renderer2,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
  group,
} from '@angular/animations';
import { GridApi, ColDef } from 'ag-grid-community';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

// import { SlideInOutAnimation } from '../animations';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import * as moment from 'moment';
import { Router, NavigationExtras } from '@angular/router';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { GlobalService } from 'src/app/services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
// ModuleRegistry.registerModules([AllCommunityModule]);
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule, // for *ngIf, *ngFor
    FormsModule, // for [(ngModel)]
    ReactiveFormsModule,
    AgGridModule, // if you're using [formGroup], formControlName
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('toggleBox', [
      // ...
      state(
        'open',
        style({
          height: 'auto',
          backgroundColor: 'transparent',
        })
      ),
      state(
        'closed',
        style({
          height: '0px',
          backgroundColor: 'transparent',
        })
      ),
      transition('open => closed', [animate('0.3s')]),
      transition('closed => open', [animate('0.3s')]),
    ]),
  ],
})
export class DashboardComponent implements OnInit {
  display: any = 'none';
  dashboardData: any;
  totalColg: any;
  preferedCourseData: any;
  totalCourse: any;
  totalStudents: any;
  trendingCourse: any;
  abroardUniver: any;
  studentDetails: any;

  hideSideNav: boolean;
  showTour: any;
  flag: boolean = true;
  showClose: boolean = true;
  showMenu: boolean = false;

  @ViewChild('el') elRefs: ElementRef;

  isOpen = false;
  animationState = 'out';

  showAdd = false;
  showEdit = false;

  studentForm: UntypedFormGroup;
  phonenumber: any;
  studentName: any;
  emailAddress: any;
  firstGraduate: any;
  quota: any;
  community: any;
  choiceOfCourse: any;
  choiceOfCollege: any;
  qualification: any;
  clgName: any;
  fatherName: any;
  place: any;
  district: any;
  dob: any;
  password: any;
  confirmPassword: any;
  showErr = false;
  preferredCourse: any;
  referral: any;
  userRole: any;
  preferedCourseEdit: any[];

  searchForm: UntypedFormGroup;

  showData = false;
  showNodata = false;
  searchval: any;

  error_messages = {
    studentImg: [{ type: 'required', message: 'please select student image' }],
    userRoleVal: [{ type: 'required', message: 'please enter user role' }],
    studentNameVal: [
      { type: 'required', message: 'please enter student name' },
    ],
    phoneno: [
      { type: 'required', message: 'please enter student whatsapp number' },
      { type: 'maxlength', message: 'Phone Number should be 10 digit' },
      { type: 'minlength', message: 'Phone Number should be 10 digit' },
      { type: 'pattern', message: 'Phone Number should be Numbers only' },
    ],
    email: [
      { type: 'required', message: 'please enter email address' },
      { type: 'pattern', message: 'Please enter a valid email address' },
    ],

    firstGraduateVal: [
      { type: 'required', message: 'please Select First Graduate' },
    ],

    quotaVal: [{ type: 'required', message: 'please Select Quota' }],

    communityVal: [{ type: 'required', message: 'please Select Community' }],

    choiceOfCourseVal: [
      { type: 'required', message: 'please enter school or college name' },
    ],
    choiceOfCollegeVal: [
      { type: 'required', message: 'please enter school or college name' },
    ],

    colgVal: [
      { type: 'required', message: 'please enter school or college name' },
    ],
    fatherNameVal: [{ type: 'required', message: 'please enter father name' }],
    qualificationVal: [
      {
        type: 'required',
        message: 'please enter student educational qualification',
      },
    ],
    placeVal: [{ type: 'required', message: 'please enter place' }],
    districtVal: [{ type: 'required', message: 'please select district' }],
    dobVal: [{ type: 'required', message: 'please select date of birth' }],

    paswdVal: [{ type: 'required', message: 'please enter password' }],
    confirmPass: [
      { type: 'required', message: 'please enter confirm password' },
    ],
    preferredCourseVal: [
      { type: 'required', message: 'please select preferred courses' },
    ],
    referralVal: [{ type: 'required', message: 'please enter referral code' }],
    fatherMobileVal: [
      { type: 'required', message: 'please enter fathers mobile number' },
      { type: 'maxlength', message: 'Phone Number should be 10 digit' },
      { type: 'minlength', message: 'Phone Number should be 10 digit' },
      { type: 'pattern', message: 'Phone Number should be Numbers only' },
    ],
    // 'searchInput': [
    //   { type: 'required', message: 'please enter referral code' },
    // ],
  };
  imageUrl: any;
  fileToUpload: File;
  disrictData: any;
  userRoleData: any;
  id: any;
  adminName: any;
  adminImage: any;
  allStudents: any;
  allData: any;
  imageTrueFalse: boolean = false;
  payload: any;
  fatherMobile: any;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public router: Router,
    public ngzone: NgZone,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    public formBuilder: UntypedFormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService
  ) {
    this.imageUrl = this.commonservice.base64profile;

    this.studentForm = this.formBuilder.group(
      {
        studentImg: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        userRoleVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        studentNameVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        phoneno: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10),
            Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          ])
        ),
        email: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.email,
            Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
          ])
        ),

        firstGraduateVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),

        quotaVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),

        communityVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),

        choiceOfCourseVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),

        choiceOfCollegeVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),

        colgVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        fatherNameVal: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10),
            Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          ])
        ),
        fatherMobileVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        qualificationVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        placeVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        districtVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        dobVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),

        paswdVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        confirmPass: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        preferredCourseVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        referralVal: new UntypedFormControl(
          '',
          Validators.compose([Validators.required])
        ),
        // searchInput: new FormControl('', Validators.compose([
        //   Validators.required,
        // ])),
      },
      {
        validators: this.passwordValidate.bind(this),
      }
    );

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);
    // console.log("Admin Data", adminData[0].name);
    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = '../tenant-avatar.jpg';
    }
  }

  userActive(student, status) {
    const servicePath = this.utils.getApiConfigs('users');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, {
        id: student.id,
        user_status: status,
      })
      .then((resp: any) => {
        // console.log("Dashboard", resp);
        if (resp.status_code == '200') {
          this.spinner.show();
          const servicePathStud = this.utils.getApiConfigs('studentlist');
          this.commonservice
            .invokeService(
              servicePathStud[0].method,
              servicePathStud[0].path,
              ''
            )
            .then((resp: any) => {
              this.spinner.hide();
              console.log('Students', resp.data);
              if (resp.status_code == '200') {
                this.spinner.hide();
                this.studentDetails = resp.data;
                if (this.studentDetails == '') {
                  this.showNodata = true;
                  this.showData = false;
                } else {
                  this.showData = true;
                  this.showNodata = false;

                  for (var i = 0; i < this.studentDetails.length; i++) {
                    let date = this.studentDetails[i].date;
                    date = moment().format('DD-MM-YYYY');
                    this.studentDetails[i]['displayDate'] = date;

                    let dateOF = this.studentDetails[i].dob;
                    this.studentDetails[i]['dateOfBirth'] =
                      moment(dateOF).format('DD-MM-YYYY');

                    // if (
                    //   this.studentDetails[i].image == null ||
                    //   this.studentDetails[i].image == undefined
                    //   ) {
                    //     this.studentDetails[i].image = 'assets/tenant-avatar.jpg';
                    //   }
                  }
                }
              }

              this.allStudents = this.studentDetails;
            });

          // console.log("total", this.totalColg);
        }
      });
  }

  userPermission(student, status) {
    var payload = {
      id: student.id,
      isAllow: status,
    };
    console.log('>>>userPermissionallow>', payload);
    const servicePath = this.utils.getApiConfigs('userPermissionallow');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        if (resp.status_code == '200') {
          for (var i = 0; i < this.allStudents.length; i++) {
            if (this.allStudents[i].id == student.id) {
              this.allStudents[i].isAllow = status;
            }
          }
        }
      });
  }
  passwordValidate(formGroup: UntypedFormGroup) {
    const { value: password } = formGroup.get('paswdVal');
    const { value: confirmPassword } = formGroup.get('confirmPass');
    if (password === confirmPassword) {
      this.showErr = false;
    } else {
      this.showErr = true;
    }
  }

  ngOnInit(): void {
    // Get Dashboard Data \\
    const servicePath = this.utils.getApiConfigs('count');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        // console.log("Dashboard", resp);
        if (resp.status_code == '200') {
          this.dashboardData = resp.data;

          for (var i = 0; i < this.dashboardData.length; i++) {
            if (this.dashboardData[i].type == 'College') {
              this.totalColg = this.dashboardData[i].total;
            } else if (this.dashboardData[i].type == 'Courses') {
              this.totalCourse = this.dashboardData[i].total;
            } else if (this.dashboardData[i].type == 'Students') {
              this.totalStudents = this.dashboardData[i].total;
            } else if (this.dashboardData[i].type == 'Trending Course') {
              this.trendingCourse = this.dashboardData[i].total;
            } else if (this.dashboardData[i].type == 'Abroad University') {
              this.abroardUniver = this.dashboardData[i].total;
            }
          }
          // console.log("total", this.totalColg);
        }
      });

    // Get All Students \\
    this.spinner.show();
    const servicePathStud = this.utils.getApiConfigs('studentlist');
    this.commonservice
      .invokeService(servicePathStud[0].method, servicePathStud[0].path, '')
      .then((resp: any) => {
        this.spinner.hide();
        console.log('Students', resp.data);
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.studentDetails = resp.data;
          if (this.studentDetails == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;

            for (var i = 0; i < this.studentDetails.length; i++) {
              let date = this.studentDetails[i].date;
              date = moment().format('DD-MM-YYYY');
              this.studentDetails[i]['displayDate'] = date;

              let dateOF = this.studentDetails[i].dob;
              this.studentDetails[i]['dateOfBirth'] =
                moment(dateOF).format('DD-MM-YYYY');

              // if(this.studentDetails[i].image == null || this.studentDetails[i].image == undefined){
              //   this.studentDetails[i].image = 'assets/tenant-avatar.jpg';
              // }
            }
          }
        }

        this.allStudents = this.studentDetails;
      });

    // Get All District \\
    const servicePathDistrict = this.utils.getApiConfigs('district');
    this.commonservice
      .invokeService(
        servicePathDistrict[1].method,
        servicePathDistrict[1].path,
        ''
      )
      .then((resp: any) => {
        // console.log("District", resp);
        if (resp.status_code == '200') {
          this.disrictData = resp.data;
          console.log('District', this.disrictData);
        }
      });

    // GET USER ROLE \\
    const servicePathuser = this.utils.getApiConfigs('userroles');
    this.commonservice
      .invokeService(servicePathuser[1].method, servicePathuser[1].path, '')
      .then((resp: any) => {
        // console.log("User role", resp);
        if (resp.status_code == '200') {
          this.userRoleData = resp.data;
        }
      });

    // GET PREFERD COURSE \\
    const servicePathcourse = this.utils.getApiConfigs('coursetype');
    console.log(servicePathcourse);
    this.commonservice
      .invokeService(servicePathcourse[1].method, servicePathcourse[1].path, '')
      .then((resp: any) => {
        console.log('User role', resp);
        if (resp.status_code == '200') {
          this.preferedCourseData = resp.data;
        }
      });
  }

  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);

    //Show image preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
      this.imageTrueFalse = true;
      // console.log("img", this.imageUrl);
    };

    reader.readAsDataURL(this.fileToUpload);
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    console.log('val', val);

    this.allData = this.studentDetails;

    console.log('All Data', this.allData);

    // if (val) {
    //   this.allStudents = this.allData.filter(
    //     (item) =>
    //       item.user_name.toLowerCase().includes(val.toLowerCase()) ||
    //       item.phone_num.toLowerCase().includes(val.toLowerCase()) ||
    //       item.referred_code.toLowerCase().includes(val.toLowerCase())
    //   );
    // }

    if (val) {
      const searchText = val.toLowerCase();

      this.allStudents = [
        ...new Map(
          this.allData
            .filter((item) => {
              return (
                (item.user_name?.toLowerCase() || '').includes(searchText) ||
                (item.phone_num?.toLowerCase() || '').includes(searchText) ||
                (item.referred_code?.toLowerCase() || '').includes(searchText)
              );
            })
            .map((item) => [item.user_name, item]) // Ensuring uniqueness based on `user_name`
        ).values(),
      ];
    }

    // console.log("Students Data", this.allStudents);

    if (this.allStudents == '') {
      this.globalService.showError('No data found');
    }
  }

  resetsearch() {
    this.searchval = '';
    this.ngOnInit();
    // this.commonservice.refresh();
  }

  viewStudent(data) {
    // console.log("Data", data);
    this.globalService.setLocalStore('studentDetails', JSON.stringify(data));
    this.router.navigate(['/userDetail']);
  }

  openAdd() {
    this.display = 'block';
    this.studentForm.reset();
    this.imageUrl = this.commonservice.base64profile;
    this.showAdd = true;
    this.showEdit = false;
  }

  editStudent(data) {
    console.log('Data', data);
    this.display = 'block';

    this.studentName = data.user_name;
    this.phonenumber = data.phone_num;
    this.emailAddress = data.email_id;
    this.firstGraduate = data.first_graduate;
    this.quota = data.quota;
    this.community = data.community;
    this.choiceOfCourse = data.choice_of_course;
    this.choiceOfCollege = data.choice_of_college;
    this.password = data.password;
    this.confirmPassword = data.password;
    this.place = data.place;
    this.district = data.district;
    this.dob = data.dob;
    this.fatherName = data.father_name;
    this.fatherMobile = data.father_phone_num;
    this.clgName = data.institution_name;
    this.preferredCourse = data.prefered_course[0];
    this.qualification = data.educational_qualification;
    this.id = data.id;
    this.userRole = data.role_id;
    this.imageUrl = data.image;
    this.showAdd = false;
    this.showEdit = true;
  }

  addStudent() {
    this.spinner.show();
    let preferedCourse = [];
    preferedCourse = this.preferredCourse.split(',');
    // console.log("prefered course", preferedCourse);

    let payload = {
      role_id: this.userRole,
      name: this.studentName,
      phone_number: this.phonenumber,
      email_id: this.emailAddress,
      first_graduate: this.firstGraduate,
      quota: this.quota,
      community: this.community,
      choice_of_course: this.choiceOfCourse,
      choice_of_college: this.choiceOfCollege,
      password: this.confirmPassword,
      place: this.place,
      district: this.district,
      dob: this.dob,
      father_name: this.fatherName,
      father_phone_num: this.fatherMobile,
      institution_name: this.clgName,
      prefered_course: preferedCourse,
      educational_qualification: this.qualification,
      referred_code: this.referral,
      user_image: this.imageUrl,
    };

    console.log('payload', payload);
    const servicePath = this.utils.getApiConfigs('users');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp);
          this.spinner.hide();
          this.globalService.showSuccess('Student Added Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.studentForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
    // }
  }

  updateStudent() {
    this.spinner.show();
    if (typeof this.preferredCourse === 'string') {
      this.preferedCourseEdit = this.preferredCourse.split(',');
    } else {
      this.preferedCourseEdit = this.preferredCourse;
    }

    let dob = moment(this.dob).format('YYYY-MM-DD');

    // console.log("imageTrueFalse", this.imageTrueFalse);

    if (this.imageTrueFalse == true) {
      this.payload = {
        id: this.id,
        role_id: this.userRole,
        user_name: this.studentName,
        phone_num: this.phonenumber,
        email_id: this.emailAddress,
        first_graduate: this.firstGraduate,
        quota: this.quota,
        community: this.community,
        choice_of_course: this.choiceOfCourse,
        choice_of_college: this.choiceOfCollege,
        // "password": this.confirmPassword,
        place: this.place,
        district: this.district,
        dob: dob,
        father_name: this.fatherName,
        institution_name: this.clgName,
        prefered_course: this.preferedCourseEdit,
        user_image: this.imageUrl,
        educational_qualification: this.qualification,
      };
    } else {
      this.payload = {
        id: this.id,
        role_id: this.userRole,
        user_name: this.studentName,
        phone_num: this.phonenumber,
        email_id: this.emailAddress,
        first_graduate: this.firstGraduate,
        quota: this.quota,
        community: this.community,
        choice_of_course: this.choiceOfCourse,
        choice_of_college: this.choiceOfCollege,
        // "password": this.confirmPassword,
        place: this.place,
        district: this.district,
        dob: dob,
        father_name: this.fatherName,
        institution_name: this.clgName,
        prefered_course: this.preferedCourseEdit,
        educational_qualification: this.qualification,
      };
    }

    // console.log("payload", this.payload);
    const servicePath = this.utils.getApiConfigs('users');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, this.payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp);
          this.spinner.hide();
          this.globalService.showSuccess('Student updated successfully');
          this.display = 'none';
          this.ngOnInit();
          this.imageTrueFalse = false;
          this.studentForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
    // }
  }

  /**
   * Close modal when click close button
   */
  onCloseHandled() {
    this.display = 'none';
  }
  /**
   * click ok to logout from the app
   */
  ok() {
    // console.log("Logout");
    this.router.navigate(['/sign-in']);

    // this.showError = false;
    // let servicePath = this.utils.getApiConfigs("logout");
    // this.commonservice.invokeService(servicePath[0].method, servicePath[0].path, '')
    //   .then((respVal: any) => {
    //     if (respVal.payload.status == 200) {
    //       localStorage.clear();
    //       this.authservice.userActive.next(false);
    //       this.router.navigate(['/signin']);
    //     } else {
    //       this.showError = true;
    //       this.ErrorMsg = "Failed to logout";
    //       // const modalRef = this.modalService.open(ModalPopupComponent);
    //       // modalRef.componentInstance.flag = 'expire';
    //       this.router.navigate(['/signin']);
    //     }
    //   });
  }
  // goPage(num, page, flag) {
  //   console.log("num","Page", "Flag", num, page, flag);
  //   if (page != undefined) {
  //     if (page != 'logout') {
  //       let url = '/' + page + '';
  //       this.router.navigate([url])
  //     } else {
  //       this.logout();
  //     }
  //   }
  //   this.hideMenu();
  // }
  hideMenu() {
    if (this.commonservice.screenWidth <= 910) {
      this.commonservice.showTour = { 'margin-left': '-250px' };
    } else {
      this.commonservice.showTour = { 'margin-left': '0px' };
    }
  }

  notallow() {
    // this.router.navigate(['/signin']);
    this.display = 'none';
    // localStorage.clear();
  }

  gridApi!: GridApi;

  // columnDefs: ColDef[] = [
  //   { headerName: 'S.No', valueGetter: 'node.rowIndex + 1', width: 90 },

  //   {
  //     headerName: 'User Name',
  //     field: 'user_name',
  //     flex: 1,
  //     cellRenderer: (params) => {
  //       return `
  //         <div style="display:flex; align-items:center;">
  //           <img src="assets/tenant-avatar.jpg"
  //                width="30" height="30"
  //                style="border-radius:50%; margin-right:8px;" />
  //           <span>${params.value || ''}</span>
  //         </div>
  //       `;
  //     },
  //   },
  //   { headerName: 'Date of Joining', field: 'date' },
  //   { headerName: 'Phone Number', field: 'phone_num' },
  //   { headerName: 'Email Address', field: 'email_id' },
  //   { headerName: "Father's Name", field: 'father_name' },
  //   { headerName: 'Date of Birth', field: 'dateOfBirth' },
  //   { headerName: 'District', field: 'district' },
  //   { headerName: 'Referral code', field: 'referal_code' },
  //   { headerName: 'Referred code', field: 'referred_code' },

  //   {
  //     headerName: 'Status',
  //     field: 'user_status',
  //     cellRenderer: (params) => {
  //       return params.value == 1
  //         ? `<button class="btn btn-sm btn-danger">Inactive</button>`
  //         : `<button class="btn btn-sm btn-success">Active</button>`;
  //     },
  //     onCellClicked: (params) => {
  //       const newStatus = params.data.user_status == 1 ? 0 : 1;
  //       this.userActive(params.data, newStatus);
  //     },
  //   },
  //   {
  //     headerName: 'Permission',
  //     field: 'isAllow',
  //     cellRenderer: (params) => {
  //       const checked = params.value ? 'checked' : '';
  //       return `
  //         <label class="switch">
  //           <input type="checkbox" ${checked} />
  //           <span class="slider"></span>
  //         </label>
  //       `;
  //     },
  //     onCellClicked: (params) => {
  //       const newStatus = !params.data.isAllow;
  //       this.userPermission(params.data, newStatus);
  //     },
  //   },
  //   {
  //     headerName: 'Action',
  //     cellRenderer: () => {
  //       return `
  //         <i class="fa fa-pencil iconEdit" title="Edit"></i>
  //         <i class="fa fa-eye iconEdit" title="View"></i>
  //       `;
  //     },
  //     onCellClicked: (params) => {
  //       if (
  //         (params.event.target as HTMLElement).classList.contains('fa-pencil')
  //       ) {
  //         this.editStudent(params.data);
  //       } else if (
  //         (params.event.target as HTMLElement).classList.contains('fa-eye')
  //       ) {
  //         this.viewStudent(params.data);
  //       }
  //     },
  //   },
  // ];
  public columnDefs: ColDef[] = [
    {
      headerName: 'S.No',
      valueGetter: 'node.rowIndex + 1',
      width: 40,
      minWidth: 35,
      maxWidth: 50,
      suppressSizeToFit: true, // prevent auto-resize from stretching
      cellStyle: { textAlign: 'center', padding: '0 4px' },
    },
    {
      headerName: 'User Name',
      field: 'user_name',
      flex: 1,
      cellRenderer: (params) => {
        return `
          <div style="display:flex; align-items:center;">
            <img src="assets/tenant-avatar.jpg" 
                 width="30" height="30" 
                 style="border-radius:50%; margin-right:8px;" />
            <span>${params.value || ''}</span>
          </div>
        `;
      },
    },
    { headerName: 'Date of Joining', field: 'date' },
    { headerName: 'Phone Number', field: 'phone_num' },
    { headerName: 'Email Address', field: 'email_id' },
    { headerName: "Father's Name", field: 'father_name' },
    { headerName: 'Date of Birth', field: 'dateOfBirth' },
    { headerName: 'District', field: 'district' },
    { headerName: 'Referral code', field: 'referal_code' },
    { headerName: 'Referred code', field: 'referred_code' },
    {
      headerName: 'Status',
      field: 'user_status',
      width: 120, // compact width
      minWidth: 100, // allow smaller if needed
      maxWidth: 140, // prevent it from stretching too much
      suppressSizeToFit: true, // don't let auto-fit resize this column
      cellRenderer: (params) => {
        return params.value == 1
          ? `<button class="btn btn-sm btn-danger">Inactive</button>`
          : `<button class="btn btn-sm btn-success">Active</button>`;
      },
      onCellClicked: (params) => {
        const newStatus = params.data.user_status == 1 ? 0 : 1;
        this.userActive(params.data, newStatus);
      },
    },

    // {
    //   headerName: 'Permission',
    //   field: 'isAllow',
    //   width: 100,
    //   minWidth: 80,
    //   maxWidth: 120,
    //   suppressSizeToFit: true,
    //   cellRenderer: (params) => {
    //     const checked = params.value ? 'checked' : '';
    //     return `
    //   <label class="toggle-switch">
    //     <input type="checkbox" ${checked} class="toggle-input" />
    //     <span class="toggle-slider"></span>
    //   </label>
    // `;
    //   },
    //   onCellClicked: (params) => {
    //     // make sure we clicked on the input, not just the cell
    //     const target = params.event.target as HTMLElement;
    //     if (target && target.classList.contains('toggle-input')) {
    //       const newStatus = !params.data.isAllow;
    //       this.userPermission(params.data, newStatus);

    //       // update grid visually
    //       params.node.setDataValue('isAllow', newStatus);
    //     }
    //   },
    // },
    {
      headerName: 'Permission',
      field: 'isAllow',
      width: 100,
      minWidth: 80,
      maxWidth: 120,
      suppressSizeToFit: true,
      cellRenderer: (params) => {
        const checked = params.value ? 'checked' : '';
        // Inline CSS ensures styles apply even when Angular encapsulation prevents global styles reaching cell content
        return `
      <style>
        .switch-toggle-inline { position: relative; display: inline-block; width: 42px; height: 22px; }
        .switch-toggle-inline .switch-input { opacity: 0; width: 0; height: 0; position: absolute; left: -9999px; }
        .switch-toggle-inline .switch-slider { position: absolute; top:0; left:0; right:0; bottom:0; background:#ccc; border-radius:22px; transition:0.26s; }
        .switch-toggle-inline .switch-slider:before { content:""; position:absolute; height:18px; width:18px; left:2px; bottom:2px; background:#fff; border-radius:50%; transition:0.26s; box-shadow:0 1px 3px rgba(0,0,0,0.18); }
        .switch-toggle-inline .switch-input:checked + .switch-slider { background:#28a745; }
        .switch-toggle-inline .switch-input:checked + .switch-slider:before { transform: translateX(20px); }
        .switch-toggle-inline { cursor: pointer; user-select: none; -webkit-user-select: none; }
      </style>

      <label class="switch-toggle-inline" data-id="${params.data?.id ?? ''}">
        <input type="checkbox" class="switch-input" ${checked} />
        <span class="switch-slider"></span>
      </label>
    `;
      },
      onCellClicked: (params) => {
        const target = params.event.target as HTMLElement;
        if (
          target.classList.contains('switch-input') ||
          target.closest('.switch-toggle-inline')
        ) {
          const newStatus = !params.data.isAllow;
          this.userPermission(params.data, newStatus);
          params.node.setDataValue('isAllow', newStatus);
        }
      },
    },

    {
      headerName: 'Action',
      cellRenderer: () => {
        return `
          <i class="fa fa-pencil iconEdit" title="Edit"></i>
          <i class="fa fa-eye iconEdit" title="View"></i>
        `;
      },
      onCellClicked: (params) => {
        if (
          (params.event.target as HTMLElement).classList.contains('fa-pencil')
        ) {
          this.editStudent(params.data);
        } else if (
          (params.event.target as HTMLElement).classList.contains('fa-eye')
        ) {
          this.viewStudent(params.data);
        }
      },
    },
  ];
  searchText: string = '';

  onFilterChanged() {
    if (this.gridApi) {
      this.gridApi.setGridOption('quickFilterText', this.searchText);
    }
  }

  defaultColDef: ColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    flex: 1,
    minWidth: 120,
    wrapText: true,
    autoHeight: true,
  };

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  public paginationPageSize = 20; // default
  onPageSizeChanged(event: any) {
    this.paginationPageSize = Number(event.target.value);
  }
  // defaultColDef: ColDef = {
  //   resizable: true,
  //   sortable: true,
  //   filter: true,
  //   minWidth: 120,
  // };
}
